module.exports = __webpack_public_path__ + "static/media/checked.e56897f5.svg";